/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as msRest from "@azure/ms-rest-js";
import * as Models from "../models";
import * as Mappers from "../models/contactMappers";
import * as Parameters from "../models/parameters";
import { ProfiBazaAPIContext } from "../profiBazaAPIContext";

/** Class representing a Contact. */
export class Contact {
  private readonly client: ProfiBazaAPIContext;

  /**
   * Create a Contact.
   * @param {ProfiBazaAPIContext} client Reference to the service client.
   */
  constructor(client: ProfiBazaAPIContext) {
    this.client = client;
  }

  /**
   * @param subjectId
   * @param [options] The optional parameters
   * @returns Promise<Models.ContactGetByIdResponse>
   */
  getById(subjectId: string, options?: msRest.RequestOptionsBase): Promise<Models.ContactGetByIdResponse>;
  /**
   * @param subjectId
   * @param callback The callback
   */
  getById(subjectId: string, callback: msRest.ServiceCallback<Models.ContactDto[]>): void;
  /**
   * @param subjectId
   * @param options The optional parameters
   * @param callback The callback
   */
  getById(subjectId: string, options: msRest.RequestOptionsBase, callback: msRest.ServiceCallback<Models.ContactDto[]>): void;
  getById(subjectId: string, options?: msRest.RequestOptionsBase | msRest.ServiceCallback<Models.ContactDto[]>, callback?: msRest.ServiceCallback<Models.ContactDto[]>): Promise<Models.ContactGetByIdResponse> {
    return this.client.sendOperationRequest(
      {
        subjectId,
        options
      },
      getByIdOperationSpec,
      callback) as Promise<Models.ContactGetByIdResponse>;
  }
}

// Operation Specifications
const serializer = new msRest.Serializer(Mappers);
const getByIdOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "subjects/Contact/subjectContacts/{subjectId}",
  urlParameters: [
    Parameters.subjectId0
  ],
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "ContactDto"
            }
          }
        }
      }
    },
    default: {}
  },
  serializer
};
